import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
/// React router dom
import {  Routes, Route, Outlet, useLocation } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";

/// Dashboard
import Home from "./components/Dashboard/Home";

/// Material Logs
import MaterialLogs from "./components/MaterialLogs/MaterialLogs";
/// Materials Stock
import MaterialsStock from "./components/MaterialsStock/MaterialsStock";
/// Recipes
import Recipes from "./components/Recipes/Recipes";
import RecipeDetail from "./components/Recipes/RecipeDetail";
import RecipesNutritionFacts from "./components/Recipes/RecipesNutritionFacts";

/// Products
import Products from "./components/Products/Products";
import ProductStock from "./components/Products/ProductStock";

/// Orders
import CreateOrder from "./components/Orders/CreateOrder";
import OrderDetail from "./components/Orders/OrderDetail";
import OrdersPage from "./components/Tasks/TasksPage";
import OrdersStatistics from "./components/Orders/OrdersStatistics";
import MarketingReport from "./components/Orders/MarketingReport";
import RompslompSettings from "./components/Settings/RompslompSettings";

/// Invoices
import Invoices from "./components/Invoices/Invoices";
/// Settings
import EmailTemplatesSettings from "./components/Settings/EmailTemplatesSettings";
import InternalOrderAlerts from "./components/Settings/InternalOrderAlerts";
import TelegramAlerts from "./components/Settings/TelegramAlerts";
import EmailSendingSettings from "./components/Settings/EmailSendingSettings";
import TrackingSettings from "./components/Settings/TrackingSettings";
import AccountingSettings from "./components/Settings/AccountingSettings";
import Suppliers from "./components/Suppliers/Suppliers";
import SuppliersAnalysis from "./components/SuppliersAnalysis/SuppliersAnalysis";
import Expenses from "./components/Expenses/Expenses";

/// Users
import Users from "./components/Users/Users";
import UserLogs from "./components/UserLogs/UserLogs";

/// Pages (Error, Lock)
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeContext } from "../context/ThemeContext";
import { navtoggle } from "../store/actions/AuthActions";
import { canViewModule } from "../services/AuthService";

const allroutes = [
  // Dashboard
  { url: "", component: <Home />, moduleKey: 'dashboard' },
  { url: "dashboard", component: <Home />, moduleKey: 'dashboard' },
  // Materials
  { url: 'materials', component: <MaterialLogs />, moduleKey: 'materials' },
  // Materials Stock
  { url: 'materials-stock', component: <MaterialsStock />, moduleKey: 'materials_stock' },
  // Recipes
  { url: 'recipes', component: <Recipes />, moduleKey: 'recipes' },
  { url: 'recipes/nutrition-facts', component: <RecipesNutritionFacts />, moduleKey: 'nutrition_facts' },
  { url: 'recipes/:id', component: <RecipeDetail />, moduleKey: 'recipes' },
  // Products
  { url: 'products', component: <Products />, moduleKey: 'products' },
  { url: 'products-stock', component: <ProductStock />, moduleKey: 'products_stock' },
  // Orders (more specific first)
  { url: 'orders/create', component: <CreateOrder />, moduleKey: 'orders' },
  { url: 'orders/statistics', component: <OrdersStatistics />, moduleKey: 'orders_statistics' },
  { url: 'orders/marketing', component: <MarketingReport />, moduleKey: 'orders' },
  { url: 'orders/:id', component: <OrderDetail />, moduleKey: 'orders' },
  { url: 'orders', component: <OrdersPage />, moduleKey: 'orders' },
  // Invoices
  { url: 'invoices', component: <Invoices />, moduleKey: 'invoices' },
  // Settings (admin only)
  { url: 'settings/email-templates', component: <EmailTemplatesSettings />, moduleKey: 'settings' },
  { url: 'settings/internal-alerts', component: <InternalOrderAlerts />, moduleKey: 'settings' },
  { url: 'settings/telegram-alerts', component: <TelegramAlerts />, moduleKey: 'settings' },
  { url: 'settings/email-sending', component: <EmailSendingSettings />, moduleKey: 'settings' },
  { url: 'settings/tracking', component: <TrackingSettings />, moduleKey: 'tracking' },
  { url: 'settings/invoicing', component: <AccountingSettings />, moduleKey: 'settings' },
  { url: 'settings/rompslomp', component: <RompslompSettings />, moduleKey: 'settings' },
  { url: 'suppliers', component: <Suppliers />, moduleKey: 'suppliers' },
  { url: 'suppliers-analysis', component: <SuppliersAnalysis />, moduleKey: 'suppliers_analysis' },
  { url: 'expenses', component: <Expenses />, moduleKey: 'expenses' },
  // Users (super admin only)
  { url: 'users', component: <Users />, moduleKey: 'users' },
  // Users Logs (admin only)
  { url: 'users-logs', component: <UserLogs />, moduleKey: 'user_logs' },
];

function ProtectedRoute({ moduleKey, children }) {
  if (moduleKey && !canViewModule(moduleKey)) {
    return <Error403 />;
  }
  return children;
}

function NotFound(){    
  const url = allroutes.map((route) => route.url);
  let path = window.location.pathname
  path = path.split('/')
  path = path[path.length - 1]    
    
  if(url.indexOf(path) <= 0){     
    return <Error404 />
  }
}

const Markup = () => {   
  
   
  return (
    <>
        <Routes>              
            <Route path='/page-lock-screen' element= {<LockScreen />} />
            <Route path='/page-error-400' element={<Error400/>} />            
            <Route path='/page-error-403' element={<Error403/>} />
            <Route path='/page-error-404' element={<Error404/>} />
            <Route path='/page-error-500' element={<Error500/>} />
            <Route path='/page-error-503' element={<Error503/>} />     
            <Route  element={<MainLayout />} > 
                {allroutes.map((data, i) => (
                  <Route
                    key={i}
                    exact
                    path={`${data.url}`}
                    element={<ProtectedRoute moduleKey={data.moduleKey}>{data.component}</ProtectedRoute>}
                  />
                ))}
            </Route>                
            <Route path='*' element={<NotFound/>} />     
        </Routes>     
        <ScrollToTop />
        <ToastContainer position="top-right" autoClose={3000} />
        
    </>
  );       
};

function MainLayout(){
  const { menuToggle , sidebariconHover} = useContext(ThemeContext);
  const location = useLocation();
  const dispatch = useDispatch();
  const sideMenu = useSelector(state => state.sideMenu);

  const isNutritionFacts = location.pathname.includes('nutrition-facts');
  // Pages whose content height varies a lot (e.g. short settings forms) shouldn't be
  // force-stretched to fill the viewport — reuses the same "fit content" layout
  // (content-body-fit / data-nutrition-facts chain) originally added for the Nutrition
  // Facts page's white-space fix, see scss/_custom-overrides.scss.
  // settings/tracking added: multiple vertically-stacked cards of differing natural
  // height (prefix, label settings, stages, page text, status mapping) hit the exact
  // same theme .card{height:calc(100% - 25px)} inflation bug as row 15 originally had —
  // see ARCHITECTURE.md §4/§1 row 16b.
  const isFitContentPage = isNutritionFacts
    || location.pathname.includes('settings/email-templates')
    || location.pathname.includes('settings/internal-alerts')
    || location.pathname.includes('settings/telegram-alerts')
    || location.pathname.includes('settings/tracking')
    || location.pathname.includes('settings/invoicing')
    || location.pathname.includes('settings/rompslomp');

  useEffect(() => {
    const html = document.documentElement;
    if (isFitContentPage) {
      document.body.classList.add('body-nutrition-facts');
      html.classList.add('page-nutrition-facts');
    } else {
      document.body.classList.remove('body-nutrition-facts');
      html.classList.remove('page-nutrition-facts');
    }
    return () => {
      document.body.classList.remove('body-nutrition-facts');
      html.classList.remove('page-nutrition-facts');
    };
  }, [isFitContentPage]);

  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle": ""} ${ sideMenu ? "menu-toggle" : ""}`} data-nutrition-facts={isFitContentPage ? 'true' : undefined}>
        <Nav />
        <div className={`content-body ${isFitContentPage ? 'content-body-fit' : ''}`} style={!isFitContentPage ? { minHeight: window.screen.height - 45 } : { minHeight: 'auto' }}>
          <Outlet />
        </div>
      <Footer />
    </div>
  )
};

export default Markup;
